import * as errorBoundary from '@cascade/react/error-boundary';
import { reportError } from '@cascade/react-dom/observability';
import type { PropsWithChildren } from 'react';
import { ErrorPage } from '#views/error-page/index.ts';

export const ErrorBoundary = ({ children }: PropsWithChildren) => (
  <errorBoundary.ErrorBoundary reporter={reportError} fallback={ErrorPage}>
    {children}
  </errorBoundary.ErrorBoundary>
);
